import Poisson1 from './Poisson1';
import Poisson2 from './Poisson2';
import Poisson3 from './Poisson3';
// import Poisson4 from "./Poisson4";
import Poisson5 from './Poisson5';
import Poisson6 from './Poisson6';
import Poisson7 from './Poisson7';
import Poisson8 from './Poisson8';
import Poisson9 from './Poisson9';
import Poisson10 from './Poisson10';

export default class FishSpawner extends Phaser.GameObjects.Container {
    constructor(scene, x, y, spawnDelay) {
        super(scene, x, y, []);

        this.scene = scene;
        this.spawnDelay = spawnDelay;
        this.fishes = [];
        this.isSpawnerActive = true;
        this.fishSpeed = 200;
        scene.add.existing(this);

        this.spawner = this.scene.time.addEvent({
            delay: this.spawnDelay,
            repeat: -1,
            callback: () => {
                if (!this.isSpawnerActive) return;

                let lane = Math.floor(Math.random() * 4); // 0 ou 1

                let y;
                if (lane == 0) {
                    y = this.scene.laneTwo;
                } else if (lane == 1) {
                    y = this.scene.laneThree;
                } else if (lane == 2) {
                    y = this.scene.laneFour;
                } else if (lane == 3) {
                    y = this.scene.laneFive;
                }

                let fish = undefined;
                let random = Math.random();

                if (random > 0.9) {
                    fish = new Poisson1(this.scene, 0, y, { showHitbox: false }); // Poubelle
                } else if (random > 0.8) {
                    fish = new Poisson2(this.scene, this.scene.width, y, { showHitbox: false }); // Poubelle
                } else if (random > 0.7) {
                    fish = new Poisson3(this.scene, this.scene.width, y, { showHitbox: false }); // Poubelle
                } else if (random > 0.6) {
                    fish = new Poisson7(this.scene, this.scene.width, y, { showHitbox: false }); // Poubelle
                } else if (random > 0.5) {
                    fish = new Poisson5(this.scene, this.scene.width, y, { showHitbox: false }); // Poubelle
                } else if (random > 0.4) {
                    fish = new Poisson6(this.scene, this.scene.width, y, { showHitbox: false }); // Poubelle
                } else if (random > 0.3) {
                    fish = new Poisson7(this.scene, this.scene.width, y, { showHitbox: false }); // Poubelle
                } else if (random > 0.2) {
                    fish = new Poisson8(this.scene, this.scene.width, y, { showHitbox: false }); // Poubelle
                } else if (random > 0.1) {
                    fish = new Poisson10(this.scene, this.scene.width, y, { showHitbox: false }); // Poubelle
                } else if (random) {
                    fish = new Poisson9(this.scene, this.scene.width, y, { showHitbox: false }); // Poubelle
                }
                // if (random > 0.7) {

                //     fish = new Poisson1(this.scene, 0, y, { showHitbox: false }) // Poubelle
                // } else if (random < 0.3) {

                //     fish = new Poisson2(this.scene, this.scene.width, y, { showHitbox: false }) // Poubelle
                // } else if (random) {

                //     fish = new Poisson3(this.scene, this.scene.width, y, { showHitbox: false }) // Poubelle
                // }
                if (fish != undefined) {
                    this.fishes.push(fish);
                }
            },
        });
    }

    setActive(isActive) {
        this.isSpawnerActive = isActive;
    }

    moveObstacles(delta) {
        this.fishes.forEach((fish, index) => {
            if (
                fish.type === 'poisson1' ||
                fish.type === 'poisson3' ||
                fish.type === 'poisson7' ||
                fish.type === 'poisson8' ||
                fish.type === 'poisson9'
            ) {
                fish.x += fish.speed * ((delta / 1000) * 0.36); // On fait avancer l'fish vers le joueur
                if (fish.x >= this.scene.width) {
                    fish.destroy();
                    this.fishes.splice(index, 1); // On le supprime quand il sort de l'écran
                }
            } else {
                // console.log("fish",fish)
                // console.log("speed",fish.speed)
                // console.log("this.fishSpeed",this.fishSpeed)
                fish.x -= (fish.speed + this.fishSpeed) * (delta / 1300); // On fait avancer l'fish vers le joueur
                // console.log("speed",fish.x)
                if (fish.x <= -fish.width) {
                    fish.destroy();
                    this.fishes.splice(index, 1); // On le supprime quand il sort de l'écran
                }
            }
        });
    }
}
